import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  items: any[];

  constructor() {
    this.items = [
      {label: 'menu.home', icon: 'pi pi-home', routerLink: '/'},
      {label: 'menu.newExternalApplication', icon: 'pi pi-plus-circle', routerLink: '/external-applications/new'},
      // {label: 'menu.billing', icon: 'pi pi-credit-card', routerLink: '/billing'}
    ];
  }

  public getItems() {
    return this.items;
  }

}
